export default "__VITE_ASSET__Bfxu_mxu__"